import { localizedPill } from "../../../i18n/localized";

export type PillTone = "ok" | "warn" | "idle" | "fail" | "info";

/** Ported verbatim from the mock's PILL_MAP. */
export const PILL_MAP: Record<string, [PillTone, string]> = {
  success: localizedPill("domain.pill.success", "ok", "Success"),
  ok: localizedPill("domain.pill.ok", "ok", "OK"),
  acknowledged: localizedPill("domain.pill.acknowledged", "ok", "Acknowledged"),
  delivered: localizedPill("domain.pill.delivered", "ok", "Delivered"),
  live: localizedPill("domain.pill.live", "ok", "Live"),
  connected: localizedPill("domain.pill.connected", "ok", "Connected"),
  passed: localizedPill("domain.pill.passed", "ok", "Passed"),
  completed: localizedPill("domain.pill.completed", "ok", "Completed"),
  pending: localizedPill("domain.pill.pending", "warn", "Pending"),
  active: localizedPill("domain.pill.active", "warn", "In progress"),
  onboarding: localizedPill("domain.pill.onboarding", "warn", "Onboarding"),
  warn: localizedPill("domain.pill.warn", "warn", "Warning"),
  queued: localizedPill("domain.pill.queued", "idle", "Queued"),
  draft: localizedPill("domain.pill.draft", "idle", "Draft"),
  failed: localizedPill("domain.pill.failed", "fail", "Failed"),
  rejected: localizedPill("domain.pill.rejected", "fail", "Rejected"),
  error: localizedPill("domain.pill.error", "fail", "Error"),
  reprocessed: localizedPill("domain.pill.reprocessed", "info", "Reprocessed"),
  submitted: localizedPill("domain.pill.submitted", "info", "Submitted"),
  "self-hosted": localizedPill("domain.pill.self-hosted", "warn", "Self-hosted"),
  invited: localizedPill("domain.pill.invited", "idle", "Invited"),
  // m6-rulings.md #130: a suspended membership.
  suspended: localizedPill("domain.pill.suspended", "idle", "Suspended"),
  held: localizedPill("domain.pill.held", "fail", "Held"),
  silent: localizedPill("domain.pill.silent", "fail", "No documents"),
  // File intake batch states (m4-rulings.md #70).
  seen: localizedPill("domain.pill.seen", "info", "Seen"),
  claimed: localizedPill("domain.pill.claimed", "idle", "Claimed"),
  accepted: localizedPill("domain.pill.accepted", "ok", "Accepted"),
  partially_accepted: localizedPill("domain.pill.partially_accepted", "warn", "Partly accepted"),
  duplicate: localizedPill("domain.pill.duplicate", "idle", "Duplicate"),
};

export function StatusPill({ status, label, tone }: { status: string; label?: string; tone?: PillTone | undefined }) {
  const [mapped, fallback] = PILL_MAP[status.toLowerCase()] ?? (["idle", status] as const);
  return (
    <span className={`pill pill-${tone ?? mapped}`}>
      <i className="dot" />
      {label ?? fallback}
    </span>
  );
}
